import { SaleMethodSlim } from "src/app/components/order/fulle-selection-SM/fulle-selection-SM.interface";

export type NextSlotKind = 'NOW' | 'NEXT' | 'NONE';

export interface NextAvailableSlotInfo {
  kind: NextSlotKind;
  at?: Date;
}

export interface SlotOption {
  start: Date; // datetime réel
  end: Date;   // datetime réel
}

export interface SlotDayGroup {
  date: Date;       // date du jour (00:00)
  dow: number;      // 0..6 (0=dimanche)
  slots: SlotOption[];
}

export function normalizeSM(sm: any): SaleMethodSlim {
  const getBoolean = (value: any, defaultValue: boolean = true): boolean => {
    if (value === null || value === undefined) return defaultValue;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value !== 0;
    if (typeof value === 'string') return value !== '0' && value !== '';
    return defaultValue;
  };

  // Destructuring pour exclure les anciennes propriétés
  const { 
    disable_authentification, 
    disable_authentification_info_notes,
    limit_order_gap_str,
    ...rest 
  } = sm;

  return {
    ...rest,
    disableAuthentification: getBoolean(disable_authentification),
    disableAuthentificationInfoNotes: getBoolean(disable_authentification_info_notes),
  };
}